<template>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                @click="triggerBtn(parameter)"
                solo
                small
                :color="btn.color"
                :dark="btn.dark"
                :light="btn.light"
                elevation="20"
            >
                <v-icon>{{ btn.icon }}</v-icon>
            </v-btn>
        </template>
        <span>{{ btn.tooltip }}</span>
    </v-tooltip>
</template>

<script>
/**
 * @name DynBtn
 * @module components/Global/Utils/DynBtn
 * @description
 * A dynamic button component that can be used to create buttons with different icons, colors, and tooltips.
 * @param {Object} btn - The button object that contains the icon, color, and tooltip.
 * @param {String|Number|Object|Array|Boolean} parameter - The parameter to be passed to the triggerBtn method.
 * @emits trigger:btn - Emits the trigger:btn event with the parameter when the button is clicked.
 *
 * @example
 *  <dyn-btn
 *      v-for="(btn, index) in btns"
 *      :key="index"
 *      :btn="btn"
 *      :parameter="item"
 *      @trigger:btn="triggerBtn(btn, item)"
 *  />
 *
 * @example
 *  <dyn-btn
 *      :btn="{ icon: 'mdi-invoice-edit', color: 'indigo', tooltip: 'Edit' }"
 *      :parameter="item"
 *      @trigger:btn="triggerBtn(item)"
 *  />
 */
export default {
    name: 'DynBtn',
    props: {
        btn: Object,
        parameter: {
            type: [String, Number, Object, Array, Boolean],
            default: null,
        },
    },
    methods: {
        triggerBtn(parameter) {
            this.$emit('trigger:btn', { parameter })
        },
    },
}
</script>
